import { render } from "./_base-link.vue?vue&type=template&id=df0c7c0a&scoped=true"
import script from "./_base-link.vue?vue&type=script&lang=js"
export * from "./_base-link.vue?vue&type=script&lang=js"

import "./_base-link.vue?vue&type=style&index=0&id=df0c7c0a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df0c7c0a"]])

export default __exports__